var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Chart',{ref:"chart",staticStyle:{"height":"100%"},attrs:{"dataSource":_vm.dataSource,"chartConfig":_vm.chartConfig,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }